import React from 'react'
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer'

const Info = () => {

  const { ref , inView } = useInView({threshold : 0.3});

  useEffect(()=>{
    if(inView){
      document.querySelectorAll(".about__box").forEach((item)=>{
        item.style.transform = "translateX(0)"
        item.style.opacity = 1
      })
    }
    else {
      document.querySelectorAll(".about__box").forEach((item)=>{
        item.style.transform = "translateX(200px)"
        item.style.opacity = 0
      })
    }
  },[inView])
  return (
    <div>
      <div className="grid about__info" ref={ref}>
        <div alt="work" className="about__box">
          <i className='bx bx-award about__icon'></i>
          <h3 className="about__title">Experience</h3>
          <span className="about__subtitle">3 years</span>
        </div>

        <div alt="work" className="about__box" style={{"transitionDelay" : "0.2s"}}>
          <i className='bx bx-briefcase about__icon'></i>
          <h3 className="about__title">Completed</h3>
          <span className="about__subtitle">15+ projects</span>
        </div>

        <div alt="work" className="about__box" style={{"transitionDelay" : "0.4s"}}>
          <i className='bx bx-support about__icon'></i>
          <h3 className="about__title">Support</h3>
          <span className="about__subtitle">Online 24/7</span>
        </div>

      </div>
    </div>
  )
}

export default Info